import { render, staticRenderFns } from "./BillingRules.vue?vue&type=template&id=387cfa4a&scoped=true&"
import script from "./BillingRules.vue?vue&type=script&lang=js&"
export * from "./BillingRules.vue?vue&type=script&lang=js&"
import style0 from "./BillingRules.vue?vue&type=style&index=0&id=387cfa4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387cfa4a",
  null
  
)

export default component.exports